import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
  max-width: ${layout.maxWidth};
  margin: 0 auto;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    gap: ${space[8]};
    padding: ${space[6]} ${layout.horizontalPadding};
  }
`;

export const LeftColumn = styled.div`
  text-align: center;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 40%;
    flex-shrink: 0;
    position: sticky;
    top: ${space[6]};
    align-self: flex-start;
    text-align: left;
  }
`;

export const CategoryImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 4 / 3;
    border-radius: ${layout.borderRadiusLg};
  }
`;

export const CategoryImagePlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: ${colors.lighterGrey};

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 4 / 3;
    border-radius: ${layout.borderRadiusLg};
  }
`;

export const CategoryHeading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: ${space[4]} 0 0;
  line-height: 1.3;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
    margin: ${space[5]} 0 0;
  }
`;

export const DescriptionWrapper = styled.div`
  margin: ${space[3]} ${space[4]} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin: ${space[3]} 0 0;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  flex: 1;
  min-width: 0;
  padding: 0 ${space[4]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0;
  }
`;
